import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useLanguage } from '../contexts/LanguageContext';
 

const SectionContainer = styled.section`
  position: relative;
  min-height: 400px;
  background: url('/images/THE ART OF DETAILS.webp') 75% center/cover no-repeat;
  @media (max-width: 600px) {
    min-height: 200px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.05);
`;

const ContentWrapper = styled.div`
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 600px) {
    padding: 24px;
  }
`;

const TextBox = styled.div`
  max-width: 420px;
  text-align: left;
`;

const Title = styled(motion.h2)`
  font-family: 'Tiro Bangla', serif;
  font-size: clamp(22px, 3.6vw, 34px);
  font-weight: 400;
  text-transform: uppercase;
  color: #6f6f6f;
  letter-spacing: 1px;
  margin-bottom: 6px;
`;

const Subtitle = styled(motion.p)`
  font-family: 'Barlow Semi Condensed', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.7;
  color: #9a9a9a;
  @media (max-width: 600px) {
    color: #2c2c2c; /* much darker grey on mobile for readability */
  }
`;

/* Removed stats grid to match the banner design */

const DetailsSection = () => {
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });
  const { lang } = useLanguage();

  // Removed variants and stats array from the previous layout

  return (
    <SectionContainer ref={ref}>
      <Overlay />
      <ContentWrapper>
        <TextBox>
          <Title
            initial={{ opacity: 0, y: 10 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            {lang === 'fr' ? "L'ART DU DÉTAIL" : 'THE ART OF DETAIL'}
          </Title>
          <Subtitle
            initial={{ opacity: 0, y: 10 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            {lang === 'fr'
              ? <>Des coutures de la robe jusqu'aux bijoux intemporels</>
              : <>From the gown’s delicate<br />stitching to timeless jewelry</>}
          </Subtitle>
        </TextBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default DetailsSection;
